import axios from "axios";
import JSZipUtils from 'jszip-utils'

// 标准时间转日期格式
const utils = {
    msToDate: function (msec) {
      const datetime = new Date(msec)
      const year = datetime.getFullYear()
      const month = datetime.getMonth()
      const date = datetime.getDate()
      const hour = datetime.getHours()
      const minute = datetime.getMinutes()
      const second = datetime.getSeconds()
  
      const result1 =
        year +
        '-' +
        (month + 1 >= 10 ? month + 1 : '0' + (month + 1)) +
        '-' +
        (date + 1 < 10 ? '0' + date : date) +
        ' ' +
        (hour + 1 < 10 ? '0' + hour : hour) +
        ':' +
        (minute + 1 < 10 ? '0' + minute : minute) +
        ':' +
        (second + 1 < 10 ? '0' + second : second)
  
      const result2 =
        year +
        '-' +
        (month + 1 >= 10 ? month + 1 : '0' + (month + 1)) +
        '-' +
        (date + 1 < 10 ? '0' + date : date)
  
      const result = {
        hasTime: result1,
        withoutTime: result2
      }
  
      return result
    },
    
    downloadFile: function (url) {
      // 创建一个隐藏的a标签
      const a = document.createElement('a')
      a.href = url
      // a.download = filename // 设置下载文件名
      // a.style.display = 'none' // 隐藏元素
      document.body.appendChild(a)
      a.click() // 模拟点击下载文件
      document.body.removeChild(a) // 下载完成移除元素
    },


    //根据下载链接生成文件的arrayBuffer
    async getAssetsFromOrigin(url) {
        return new Promise((resolve, reject) => {
          JSZipUtils.getBinaryContent(url, (err, data) => {
            if (err) {
              reject(err)
            } else {
              resolve(data)
            }
          })
        })
      },

  }
  
  export default utils
  